export default __webpack_public_path__ + "static/N0056-3081de28a759be87f57cd739e313a8c8.png";